import { NotificationManager } from 'react-notifications';
import ApiHeaders, {authHeader} from '../routes/Headers';
import ServerConfig from "../routes/Host";
import { hashHistory } from 'react-router';
import {userActions} from "actions/user.actions";
import reduxStore from "stores/index";
import Config from "../constants/Configuration";
import ApiException from "./ApiException";

const store = reduxStore();

export const handleApiError = (error) => {
  if (error.message === "Expired token") {
    handleExpiredToken();
    return;
  }

  NotificationManager.error(error.message, 'Wystąpił błąd', 5000);

  throw error;
  // return Promise.reject();
};

export const handleExpiredToken = () => {
  store.dispatch(userActions.logout());
  hashHistory.push('login');
  NotificationManager.error("Twoja sesja wygasła. Prosimy o ponowne zalogowanie się.", 'Wystąpił błąd', 5000);
};

export const handleApiResponse = (json) => {
  if (json.status === 'error') {
    let message = 'message' in json ? json.message : 'Błąd połączenia';
    throw new ApiException(message, json.validation, json.additionalData);
  }

  return json;
};

export const defaultConfig = {
  defaultErrorHandler: true,
  alwaysCallback: null
};

export const apiRequest = (url, method, data, config = null) => {
  if (typeof config === 'function') {
    config = {
      alwaysCallback: config
    };
  }
  config = Object.assign({}, defaultConfig, config);

  const fullUrl = buildUrl(url);
  const fullData = {
    ...(data || {}),
    method,
    headers: Object.assign({}, ApiHeaders, authHeader(), data && data.hasOwnProperty('headers') ? data.headers : {}),
  };
  const request = fetch(fullUrl, fullData);

  let promise = request
    .then((response) => {
      const promise = response.json().then(handleApiResponse);
      if (config.defaultErrorHandler) {
        promise.catch(handleApiError);
      }

      return promise;
    });

  if (config.alwaysCallback) {
    const alwaysCallback = (json) => {
      config.alwaysCallback(json);
      return json;
    };
    promise = promise.then(alwaysCallback, alwaysCallback);
  }

  return promise;
};

export const buildUrl = (url) => {
  const locale = localStorage.getItem('userLocale') || Config.Locale.default;

  return `${ServerConfig.host}/${locale}${url}`;
};

export const apiGet = (url, data, always = null) => {
  return apiRequest(url, 'GET', data, always);
};

export const apiPost = (url, data, always = null) => {
  return apiRequest(url, 'POST', data, always);
};

export const apiPut = (url, data, always = null) => {
  return apiRequest(url, 'PUT', data, always);
};

export const apiDelete = (url, data, always = null) => {
  return apiRequest(url, 'DELETE', data, always);
};



// WEBPACK FOOTER //
// ./utils/Api.js